import clsx from 'clsx';
import { useState } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import TabItemHeaderContainer from '~modules/tabs/TabItemHeaderContainer';
import { getFieldValue, getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export default function ModuleTabs(props: IEntityComponentProps) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const { data, className, editing, onChange, onAddNewChild, origData, stable } = props;
  const moduleClasses = clsx({
    ...className.module,
  });
  const childModuleIds = getRelatedEntityIds(data, 'field_items');
  const childModuleIdsLength = childModuleIds.length - 1;

  return (
    <div className={clsx(moduleClasses)} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className="relative px-0 col-12">
        <div className="c-module__header container relative px-0">
          <div className="col col-12 px-0">
            <EditableField
              hide={getFieldValue<boolean>(data, 'attributes.field_hide_title')}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={getFieldValue<string>(data, 'attributes.field_title.value')}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="c-tabs c-tabs--module u-margin-bottom-xs u-margin-top-sm js-tabs c-module__content">
          <ul className="c-tabs__headings-list container relative px-0">
            {childModuleIds &&
              childModuleIds.map((module, i) => {
                return (
                  <TabItemHeaderContainer
                    key={module}
                    index={i}
                    entityId={module}
                    isActive={i === activeTabIndex}
                    onClick={() => setActiveTabIndex(i)}
                    tabsEditing={editing}
                    onChange={onChange}
                    canMove={editing}
                    parentContext={data.id}
                    parentType={data.type}
                    fieldName="relationships.field_items.data"
                    siblingsLength={childModuleIdsLength}
                    dragHorizontally={true}
                  />
                );
              })}
            {editing && (
              <li className="c-tabs__heading">
                <AddLink
                  onClick={() =>
                    onAddNewChild({
                      id: origData,
                      fieldName: 'relationships.field_items.data',
                      templateType: 'paragraph--tabs_item',
                    })
                  }
                />
              </li>
            )}
          </ul>
          <div className="c-tabs__content">
            {childModuleIds &&
              childModuleIds.map((id, i) => {
                const isActive = i === activeTabIndex;
                const tabContentClassNames = clsx({
                  'c-tabs__tab': true,
                  'c-tabs__tab--active': isActive,
                  'p42-visibility-hidden': !isActive,
                });
                return (
                  <div key={i} className={tabContentClassNames}>
                    {isActive && (
                      <DraggableModuleContainer
                        parentIsStable={stable}
                        index={i}
                        key={id}
                        entityId={id}
                        parentContext={data.id}
                        parentType={data.type}
                        fieldName="relationships.field_items.data"
                        siblingsLength={childModuleIdsLength}
                        canMove={editing}
                      />
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
